export const projects = {
  hero: {
    title: 'Miradi na Programu Zetu',
    subtitle: 'Gundua jinsi tunavyofanya tofauti ya kuguswa kupitia programu zilizolengwa katika msaada wa dharura, huduma za afya, elimu, usalama wa chakula, na makazi kwa wakimbizi na jamii zilizo hatarini kote Uganda.',
  },
  categories: {
    all: 'Miradi Yote',
    food: 'Chakula',
    healthcare: 'Afya',
    shelter: 'Makazi',
    education: 'Elimu',
  },
  urgency: {
    critical: '🔴 Mahitaji Makubwa',
    high: '🟠 Kipaumbele cha Juu',
    medium: '🟡 Mahitaji Yanayoendelea',
    low: '✅ Lengo Limefikwa',
  },
  status: {
    active: 'Inaendelea',
    completed: 'Imekamilika',
  },
  card: {
    raised: 'Imekusanywa',
    goal: 'Lengo',
    funded: 'imefadhiliwa',
    supportButton: 'Unga Mkono Mradi Huu',
    completedButton: 'Mradi Umekamilika',
  },
  cta: {
    title: 'Kila Mchango Unahesabiwa',
    subtitle: 'Iwe ni $10 au $10,000 — msaada wako unafikia moja kwa moja familia zinazohitaji msaada kote Uganda. Chagua mradi wowote hapo juu au toa mchango wa jumla.',
    donateButton: 'Toa Mchango',
  },
   contact: {
     // Page Header
     title: 'Wasiliana Nasi',
     subtitle: 'Tuko hapa kusaidia na kujibu maswali yoyote unaoweza kuwa nayo. Iwapo mchangiaji, mshiriki, mjitolea, au mtu ambaye anataka kujifunza zaidi kuhusu kazi yetu—tungependa kusikia kutoka kwako.',
     responseTime: 'Kwa kawaida tunajibu ndani ya masaa 24.',
     headerCta: {
       becomePartner: 'Kuwa Mshirika',
       supportMission: 'Saidia Msingi Wetu',
     },

     // Contact Info Cards
     email: {
       title: 'Barua Pepe',
       address: 'info@handsofhope.org',
     },
     phone: {
       title: 'Nambari ya Simu',
       number: '+256773515447',
     },
     location: {
       title: 'Ofisi',
       address: 'Goma, Kaskazini Kivu\nJamhuri ya Kidemokrasia ya Kongo',
     },
     workingHours: {
       title: 'Saa za Kazi',
       weekdays: 'Jumatatu - Ijumaa',
       time: '8:00 AM - 6:00 PM',
       weekend: 'Jumamosi',
       weekendTime: '9:00 AM - 2:00 PM',
       timezone: 'Saa za Afrika ya Kati (CAT)',
     },

     // Social Media
     social: {
       title: 'Tujulikane',
       followOn: 'Tufuate kwenye',
     },

     // Quick Support Section
     quickSupport: {
       title: 'Uhitaji wa Msaada wa Haraka?',
       description: 'Iwapo unahitaji msaada wa haraka au maswali ya dharura, tafadhali wasiliana moja kwa moja:',
       callNow: 'Piga Sasa',
       emailNow: 'Tuma Barua Pepe',
       tollFree: 'Nambari bila malipo',
       hotlineNumber: '+256 800 123 456',
     },

     // Contact Form
     form: {
       title: 'Tutumie Ujumbe',
       name: 'Jina Kamili',
       email: 'Anwani ya Barua Pepe',
       phone: {
         label: 'Nambari ya Simu (Si Lazima)',
         placeholder: '+1234567890',
       },
       subject: 'Mada',
       subjectPlaceholder: 'Chagua mada',
       subjectOptions: {
         general: 'MaswaliYa Jumla',
         donation: 'Mchango na Michango',
         volunteer: 'Fursa za Kujitolea',
         partnership: 'Ushirikiano na Ushirikiano',
         media: 'Media na Waandishi',
         other: 'Nyingine',
       },
       message: 'Ujumbe Wako',
       messagePlaceholder: 'Tuambie jinsi tunavyoweza kukusaidia...',
       phoneNumberLabel: 'Nambari ya simu',
       charactersLimit: 'herufi',
       submitButton: 'Tuma Ujumbe',
       submitting: 'Inatuma...',
       successMessage: 'Asante kwa kuwasiliana nasi! Tumepokea ujumbe wako na tutajibu ndani ya masaa 24.',
       errorMessage: 'Kuna kitu kimekosa. Tafadhali jaribu tena.',
     },

     // FAQ Section
     faq: {
       title: 'Maswali Yanayoulizwa Mara kwa Mara',
       items: [
         {
           question: 'Nitapokea jibu kwa haraka gani?',
           answer: 'Tunajitahidi kujibu maswali yote ndani ya masaa 24 ya kazi. Kwa maswali ya dharura, tafadhali tumia nambari yetu ya msaada wa haraka.',
         },
         {
           question: 'Ninawezaje kujitolea kwenye Hands of Hope?',
           answer: 'Tembelea ukurasa wetu wa "Kujihusisha" kuchunguza fursa za kujitolea, au chagua "Fursa za Kujitolea" kwenye fomu ya wasiliana nao tutakusongoa kwenye mchakato.',
         },
         {
           question: 'Ni aina zipi za michango mnayokubali?',
           answer: 'Tunakubali michango ya kipato cha moja kwa moja na mara kwa mara, michango ya aina nyingine, na ushirikiano wa Kampuni. Wasiliana na timu yetu ya uhusiano na wachangiaji kwa taarifa zaidi.',
         },
         {
           question: 'Ninawezaje kuwa mshirika wa shirika lenu?',
           answer: 'Tunakaribisha ushirikiano na kampuni, NGO, na mashirika ya jamii. Chagua "Ushirikiano" kwenye fomu au utumeni barua pepe kwa partnerships@handsofhope.org.',
         },
       ],
     },

     // Map & Footer CTAs
     map: {
       title: 'Mahali Petu',
       getDirections: 'Mwelekeo',
     },
     cta: {
       partnerTitle: 'Kuwa Mshirika',
       partnerDesc: 'Jiunge nasi katika kuleta mabadiliko ya kudumu kwa kuwa mshirika wa kimkakati.',
       donateTitle: 'Saidia Msingi Wetu',
       donateDesc: 'Mchango wako, mdogo au mkubwa, unaathiri maisha moja kwa moja kote Uganda.',
       donateButton: 'Toa Mchango',
       partnerButton: 'Jifunze Zaidi',
     },
   },
};
